import type { IconData } from '@stacksjs/iconify-core'

export const shuffle: IconData = {
  "body": "<path fill=\"currentColor\" d=\"M19.548 4.837L16.875 7.51a1 1 0 0 1-1.415-1.414L16.556 5H15.1a5.22 5.22 0 0 0-5.089 4.058A5.264 5.264 0 0 0 15.105 13h1.502l-1.147-1.147a1 1 0 0 1 1.415-1.414l2.828 2.828a1 1 0 0 1 .282.562a1.01 1.01 0 0 1-.437 1.008l-2.673 2.673a1 1 0 0 1-1.415-1.414L16.556 15h-1.451a7.26 7.26 0 0 1-6.114-3.34A7.22 7.22 0 0 1 2.901 15H1a1 1 0 0 1 0-2h1.901a5.22 5.22 0 0 0 5.06-3.936A5.26 5.26 0 0 0 2.836 5H1a1 1 0 1 1 0-2h1.836a7.26 7.26 0 0 1 6.143 3.387A7.22 7.22 0 0 1 15.1 3h1.508L15.46 1.853A1 1 0 1 1 16.875.439l2.828 2.828a1 1 0 0 1 .282.562a1.01 1.01 0 0 1-.437 1.008\"/>",
  "width": 24,
  "height": 24,
  "viewBox": "0 0 24 24"
}

export default shuffle
